module.exports = __webpack_public_path__ + "img/xnr9.51275668.jpg";